export default state => !!state?.newpay?.scriptLoadFailure;
